import { render, staticRenderFns } from "./AlternativeAudioForm.vue?vue&type=template&id=504d65c8&scoped=true&"
import script from "./AlternativeAudioForm.vue?vue&type=script&lang=js&"
export * from "./AlternativeAudioForm.vue?vue&type=script&lang=js&"
import style0 from "./AlternativeAudioForm.vue?vue&type=style&index=0&id=504d65c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504d65c8",
  null
  
)

export default component.exports